import {useSelector} from 'react-redux'
import useCurrentUser from '#hooks/store/useCurrentUser'

const permissionsSelector = state => state.authentication.permissions

export const usePermissions = () => {
  const {permissions} = useCurrentUser();

  return permissions
}
